import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { getFormattedAmountValue } from '@openx/utils/lib/getFormattedAmountValue';
import { useTranslation } from 'react-i18next';
import { useDirectDealsPublisherDetails } from '../../utils/context/DirectDealsPublisherDetailsContext';
import { DynamicValueSectionItems } from './parts/DynamicValueSectionItems';
import { OverviewStatsBoxes } from './parts/OverviewStatsBoxes';

const AD_INVENTORY_STRING_REPLACE_MAP = {
  ctv_type: 'CTV_Type',
};

export const AdInventoryAndPricingSection = () => {
  const { t } = useTranslation();
  const publisherDetails = useDirectDealsPublisherDetails();

  if (!publisherDetails) {
    return null;
  }

  const hasAverageViewability =
    publisherDetails.average_viewability && Number(publisherDetails.average_viewability ?? 0) !== 0;

  return (
    <Grid
      container
      sx={{
        padding: 3,
        borderBottom: 1,
        borderColor: 'divider',
        width: 1,
      }}
    >
      <Grid size={3}>
        <Typography data-test="ad-inventory-and-pricing-section" variant="h1">
          {t('Ad Inventory & Pricing')}
        </Typography>
      </Grid>
      <Grid
        size={6}
        sx={{
          paddingTop: 1,
          marginBottom: 2,
        }}
      >
        <OverviewStatsBoxes
          boxOneTitle={t('Suggested CPM (Monthly)')}
          boxOneValue={`$${getFormattedAmountValue(publisherDetails.cpm_low)}-$${getFormattedAmountValue(publisherDetails.cpm_high)}`}
          boxTwoTitle={t('Average Viewability')}
          boxTwoValue={hasAverageViewability ? `${publisherDetails.average_viewability}%` : undefined}
        />

        <DynamicValueSectionItems
          item={publisherDetails}
          props={publisherDetails.ad_inventory_props}
          propNameMap={AD_INVENTORY_STRING_REPLACE_MAP}
        />
      </Grid>
      <Divider />
    </Grid>
  );
};
